import { ExternalToast, toast as sonner } from "sonner";
import { XIcon } from "lucide-react";

type TOptions = ExternalToast & {
  onAction?(): void;
};

const DEFAULT_DURATION = 4000;

export const toast = {
  success(message: string, options?: TOptions) {
    const id = sonner.success(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  warning(message: string, options?: TOptions) {
    const id = sonner.warning(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  error(message: string, options?: TOptions) {
    const id = sonner.error(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  info(message: string, options?: ExternalToast) {
    const id = sonner.info(message, {
      duration: DEFAULT_DURATION,
      cancel: {
        label: <XIcon className="w-5 h-5" />,
        onClick() {
          sonner.dismiss(id);
        },
      },
      ...options,
    });
    return id;
  },
  dismiss(id: string | number) {
    sonner.dismiss(id);
  },
};
